import { stockQuantitiesChanged } from '../../../../utils/stockQuantities';
import { cleanManufacturerUrl } from '../../../../utils/manufacturerUrl';
import React from 'react';
import { PRODUCT_STATES } from '../constants';
import MobileProductField from './MobileProductField';
import MobileProductHint from './MobileProductHint';
import MobileProductChoice from './MobileProductChoice';
import MobileCategoryPicker from './MobileCategoryPicker';
import { readNumber } from './mobileProductUtils';

export default function MobileProductEditorFields({
  tab,
  draft,
  change,
  categories,
  discountCategories,
  rates,
}) {
  if (tab === 'main')
    return (
      <>
        <MobileProductField
          label='Назва товару'
          value={draft.name}
          onChange={value => change('name', value)}
        />
        <div className='mp-field-grid'>
          <MobileProductField
            label='Артикул'
            value={draft.productCode}
            onChange={value => change('productCode', value)}
          />
          <MobileProductField
            label='Штрихкод'
            value={draft.barcode}
            onChange={value => change('barcode', value)}
          />
        </div>
        <div className='mp-field-grid'>
          <MobileProductField label='Штрихкод пачки' maxLength={80}
            value={draft.packBarcode} onChange={value => change('packBarcode', value)} />
          <MobileProductField label='Кількість у пачці, шт.' type='number' min='2' max='2147483647' step='1'
            inputMode='numeric' value={draft.packQuantity} onChange={value => change('packQuantity', value)} />
        </div>
        <MobileProductHint>Заповніть обидва поля або залиште обидва порожніми. Скан пачки додає вказану кількість штук.</MobileProductHint>
        <MobileProductChoice
          label='Статус'
          options={PRODUCT_STATES.filter(state => state.value)}
          value={draft.state}
          onChange={value => change('state', value)}
        />
        <MobileProductField
          label='Кількість, шт.'
          type='number'
          min='0'
          inputMode='numeric'
          value={draft.quantity}
          onChange={value => change('quantity', value)}
        />
        {draft.id && stockQuantitiesChanged(draft) && (
          <React.Fragment>
            <MobileProductField
              label='Причина зміни кількості (обов’язково)'
              multiline
              rows='3'
              value={draft.quantityChangeReason}
              onChange={value => change('quantityChangeReason', value)}
              required
              className={`form-control quantity-change-reason ${
                draft.quantityChangeReason?.trim() ? 'border-success' : 'border-danger'
              }`}
              aria-required='true'
              aria-invalid={!draft.quantityChangeReason?.trim()}
              aria-describedby='mobileQuantityChangeReasonHint'
            />
            <small id='mobileQuantityChangeReasonHint' className='text-danger d-block mb-3'>
              Обов’язково вкажіть причину, щоб зберегти зміну кількості та записати її в аудит.
            </small>
          </React.Fragment>
        )}
        <MobileProductField
          label='Дата очікуваного надходження'
          type='date'
          value={draft.expectedArrivalDate}
          onChange={value => change('expectedArrivalDate', value)}
        />
        <MobileProductField
          label='Опис'
          multiline
          rows='4'
          value={draft.description}
          onChange={value => change('description', value)}
        />
        <MobileProductField
          label='Посилання виробника'
          type='url'
          value={draft.manufacturerUrl}
          onChange={value => change('manufacturerUrl', cleanManufacturerUrl(value))}
        />
      </>
    );
  if (tab === 'prices')
    return (
      <>
        <MobileProductField
          label='Ціна продажу, грн'
          type='number'
          min='0'
          inputMode='numeric'
          value={draft.price}
          onChange={value => change('price', value)}
        />
        <MobileProductField
          label='Закупівельна ціна, грн'
          inputMode='decimal'
          value={draft.purchasePrice}
          onChange={value => change('purchasePrice', value)}
        />
        {[
          ['priceInPounds', 'Ціна у фунтах, £', 'pound_rate'],
          ['priceInUSD', 'Ціна в доларах, $', 'dollar_rate'],
          ['priceInEuro', 'Ціна в євро, €', 'euro_rate'],
        ].map(([key, label, rateKey]) => (
          <div className='mp-foreign-price' key={key}>
            <MobileProductField
              label={label}
              inputMode='decimal'
              value={draft[key]}
              onChange={value => change(key, value)}
            />
            <button
              type='button'
              className='btn btn-outline-secondary'
              disabled={
                !Number.isFinite(readNumber(draft[key])) || !(readNumber(rates[rateKey]) > 0)
              }
              onClick={() =>
                change(
                  'price',
                  String(Math.ceil(readNumber(draft[key]) * readNumber(rates[rateKey]))),
                )
              }
            >
              У гривні
            </button>
          </div>
        ))}
        <MobileProductHint>
          «У гривні» перераховує ціну продажу за збереженим курсом.
        </MobileProductHint>
        <MobileProductField
          label='Знижка, %'
          type='number'
          min='0'
          max='100'
          inputMode='numeric'
          value={draft.discount}
          onChange={value => change('discount', value)}
        />
        <MobileProductChoice
          label='Категорія знижки'
          options={[
            { value: '', label: 'Без групи знижок' },
            ...discountCategories.map(category => ({ value: category.name, label: category.name })),
          ]}
          value={draft.discountCategoryName}
          onChange={value => change('discountCategoryName', value)}
        />
      </>
    );
  return (
    <MobileCategoryPicker
      categories={categories}
      value={draft.categoryIds}
      onChange={value => change('categoryIds', value)}
    />
  );
}
